import { render, staticRenderFns } from "./AppSimilarApps.vue?vue&type=template&id=515675bc"
import script from "./AppSimilarApps.vue?vue&type=script&lang=js"
export * from "./AppSimilarApps.vue?vue&type=script&lang=js"
import style0 from "./AppSimilarApps.vue?vue&type=style&index=0&id=515675bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports